import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbAuthToken, NbTokenService } from '@nebular/auth';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private tokenService: NbTokenService;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.tokenService) {
      this.tokenService = this.injector.get(NbTokenService);
    }

    return this.tokenService.get().pipe(
      take(1),
      switchMap((token: NbAuthToken) => {
        if (token && token.isValid()) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token.getValue()}`
            },
            withCredentials: true
          });
        }
        return next.handle(request);
      })
    );
  }
}
